import _ from "lodash";
import { RULE_FILTER, PPFILTER, PRICE } from "../Constants";
import { PRICE_TYPE, PRICE_TYPE_BY_NAME } from "constants/PriceType";
import { getCurrencySymbol } from "helpers/Utils";

// used in custom upr setting (when importing gam upr)
export function transformGamUprToUprConfig({ gamUpr }) {
  let priceSection = {};
  const setForEverythingSetting = _.find(gamUpr.priceSection.priceSettings, {
    isSetForEverything: true,
  });
  if (setForEverythingSetting) {
    priceSection.priceType = setForEverythingSetting.priceType;
    priceSection.price = setForEverythingSetting.price;
    priceSection.currency = setForEverythingSetting.currency;
  } else {
    priceSection.priceType = PRICE_TYPE_BY_NAME.BRAND_SETTING;
    priceSection.price = -1; // backend json validation error if not set
    priceSection.currency = _.get(gamUpr.priceSection.priceSettings, [
      0,
      "currency",
    ]);
  }
  priceSection.brandedPriceSettings = gamUpr.priceSection.priceSettings.filter(
    (setting) => !setting.isSetForEverything
  );

  let targetingSection = {};
  if (gamUpr.targetingSection.inventory) {
    if (!isSectionEmpty(gamUpr.targetingSection.inventory.unitIds)) {
      if (!isSectionEmpty(gamUpr.targetingSection.inventory.unitIds.includes)) {
        _.set(
          targetingSection,
          ["inventory", "unitIds"],
          gamUpr.targetingSection.inventory.unitIds.includes
        );
      }
      if (!isSectionEmpty(gamUpr.targetingSection.inventory.unitIds.excludes)) {
        _.set(
          targetingSection,
          ["inventory", "excludedUnitIds"],
          gamUpr.targetingSection.inventory.unitIds.excludes
        );
      }
    }
    if (!isSectionEmpty(gamUpr.targetingSection.inventory.placementIds)) {
      _.set(
        targetingSection,
        ["inventory", "placementIds"],
        gamUpr.targetingSection.inventory.placementIds
      );
    }
    if (!isSectionEmpty(gamUpr.targetingSection.inventory.mcm)) {
      _.set(
        targetingSection,
        ["inventory", "mcm"],
        gamUpr.targetingSection.inventory.mcm
      );
    }
  }
  if (!isSectionEmpty(gamUpr.targetingSection.inventoryUrl)) {
    targetingSection.inventoryUrl = gamUpr.targetingSection.inventoryUrl;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.inventoryTypes)) {
    targetingSection.inventoryTypes = gamUpr.targetingSection.inventoryTypes;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.inventoryFormat)) {
    targetingSection.inventoryFormat = gamUpr.targetingSection.inventoryFormat;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.browser)) {
    targetingSection.browser = gamUpr.targetingSection.browser;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.country)) {
    targetingSection.country = gamUpr.targetingSection.country;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.customs)) {
    targetingSection.customs = gamUpr.targetingSection.customs;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.deviceCategory)) {
    targetingSection.deviceCategory = gamUpr.targetingSection.deviceCategory;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.mobileApplication)) {
    targetingSection.mobileApplication =
      gamUpr.targetingSection.mobileApplication;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.os)) {
    targetingSection.os = gamUpr.targetingSection.os;
  }
  if (!isSectionEmpty(gamUpr.targetingSection.videoPosition)) {
    targetingSection.videoPosition = gamUpr.targetingSection.videoPosition;
  }

  return {
    ...gamUpr,
    priceSection,
    targetingSection,
    // props: _.get(resourceById, [gamUpr.externalId, "props"], null),
  };
}

export function isSectionEmpty(section) {
  if (!section || _.isEmpty(section)) {
    return true;
  } else if (_.has(section, "includes") && _.has(section, "excludes")) {
    return _.isEmpty(section.includes) && _.isEmpty(section.excludes);
  } else if (_.has(section, "includes") && _.isEmpty(section.includes)) {
    return true;
  } else if (_.has(section, "excludes") && _.isEmpty(section.excludes)) {
    return true;
  } else {
    return false;
  }
}

export function createRuleFilters(uprs = []) {
  const intowowRules = _.filter(uprs, { __isI2wRule: true });
  const publisherRules = _.filter(uprs, { __isPubRule: true });
  return [
    {
      key: RULE_FILTER.ALL,
      name: "ALL",
      uprs: uprs,
    },
    {
      key: RULE_FILTER.INTOWOW_ONLY,
      name: "Intowow Rules",
      uprs: intowowRules,
    },
    {
      key: RULE_FILTER.PUBLISHER_ONLY,
      name: "Publisher Rules",
      uprs: publisherRules,
    },
  ];
}

export function createPPFilters({ uprs = [] }) {
  const tempPubRules = _.cloneDeep(uprs);
  const protectedRules = _.remove(tempPubRules, { __isProtected: true });
  const preservedRules = _.remove(tempPubRules, { __isPreserved: true });
  return [
    {
      key: PPFILTER.ALL,
      name: "ALL",
      uprs: uprs,
    },
    {
      key: PPFILTER.PROTECTED,
      name: "Protected UPRs",
      uprs: protectedRules,
    },
    {
      key: PPFILTER.PRESERVED,
      name: "Preserved UPRs",
      uprs: preservedRules,
    },
    {
      key: PPFILTER.NOT_PROTECTED_PRESERVED,
      name: "Not Protected or Preserved UPRs",
      uprs: tempPubRules,
    },
  ];
}

export function createPriceTypeFilters(selectedFilter) {
  const uprsGrouped = _.groupBy(selectedFilter.uprs, (upr) => {
    return _.get(upr, ["priceSection", "priceType"]);
  });
  let priceTypeFilters = _.map(_.keys(PRICE_TYPE), (pt) => {
    return {
      key: PRICE_TYPE[pt],
      name: PRICE_TYPE[pt],
      uprs: uprsGrouped[pt] || [],
    };
  });
  priceTypeFilters.unshift({
    key: "ALL",
    name: "ALL",
    uprs: selectedFilter.uprs,
  });

  return priceTypeFilters;
}

export function getPriceFilters(uprs = [], customPrice, currency) {
  const price = _.toNumber(customPrice);
  const isValidPrice = !_.isNaN(price);

  return [
    {
      key: PRICE.ALL,
      name: "ALL",
      uprs: uprs,
    },
    {
      key: PRICE.CUSTOM,
      name: `> ${getCurrencySymbol(currency)}`,
      uprs: isValidPrice
        ? uprs.filter((upr) => {
            // Some LGO still has price, so ignore lgo settings
            if (upr.priceSection.priceType === PRICE_TYPE_BY_NAME.LGO) {
              return false;
            }

            return (
              upr.priceSection.price > price ||
              (upr.priceSection.brandedPriceSettings || []).some(
                (d) => d.price > price
              )
            );
          })
        : [],
    },
  ];
}

export function getI2wResourceMappingFilters(selectedFilter) {
  const uprsGrouped = _.groupBy(selectedFilter.uprs, (upr) => {
    return _.get(upr, ["props", "type"]);
  });

  let resourceFilters = _.map(_.keys(uprsGrouped), (rt) => {
    return {
      key: rt,
      name: rt,
      uprs: uprsGrouped[rt] || [],
    };
  });
  resourceFilters.unshift({
    key: "ALL",
    name: "ALL",
    uprs: selectedFilter.uprs,
  });

  return resourceFilters;
}
